import { Group } from '@mantine/core';
import { GeneratedDocument } from '../hooks/useGeneratedDocuments';
import { ActionItem } from '../files-table/FilesTable';
import DownloadDocumentControl from './DownloadDocumentControl';
import EditDocumentControl from './EditDocumentControl';
import GeneratingIndicator from './GeneratingIndicator';

type Props = {
  doc: GeneratedDocument;
  onDownload: (fileId: number) => void;
  editAction?: ActionItem<unknown> | null;
  showGeneratingIndicator?: boolean;
};

export default function GeneratedDocumentInlineActions({
  doc,
  onDownload,
  editAction = null,
  showGeneratingIndicator = false,
}: Props) {
  const { fileId, backgroundProcess } = doc;

  const isGenerating =
    backgroundProcess?.status === 'PENDING' || backgroundProcess?.status === 'PROCESSING';
  if (isGenerating) {
    if (!showGeneratingIndicator) return null;
    return <GeneratingIndicator />;
  }

  if (!editAction && fileId === undefined) return null;

  return (
    <Group gap="xxs" wrap="nowrap">
      <EditDocumentControl editAction={editAction} />
      {fileId !== undefined && <DownloadDocumentControl onDownload={() => onDownload(fileId)} />}
    </Group>
  );
}
